<template>
  <CustomModal
    class="suggest-hotel-offer-category"
    :is-modal-open="isOpen"
    @toggleModal="closeModal"
    @onClickAway="closeModal"
    :overlay="'dark'"
    :with-header="true"
    :with-footer="true"
    :custom-classes="'tw:w-[100vw] tw:md:max-w-[456px] tw:md:w-[456px] tw:md:rounded-md tw:rounded-none'"
    dataTestId="hotel-offers-remove-modal"
  >
    <template #modalHeader>
      <p class="tw:text-xl tw:text-gray-700">{{ $t('hotel_offers_step_remove') }}</p>
    </template>

    <div>
      <p class="tw:mb-2" v-html="$t('hotel_offers_remove_info')" />
      <p class="tw:mb-6" v-html="$t('hotel_offers_feedback_info')" />
      <textarea
        class="tw:outline-none tw:w-full tw:border tw:border-gray-500 tw:rounded-md tw:p-2 tw:h-[228px] tw:max-h-[228px]"
        :placeholder="$t('hotel_offers_feedback_box')"
        @input="setRemoveFeedback($event.target.value)"
        :value="removeFeedback"
        maxLength="500"
      />
      <p class="tw:text-xs tw:text-gray-500">
        {{
          $t('hotel_offers_text_box_limit', {
            CharacterNumber: numberOfCharacters,
            CharacterLimit: 500,
          })
        }}
      </p>
    </div>

    <template #modalFooter>
      <div class="tw:gap-x-2 tw:w-full tw:flex tw:justify-end">
        <GhostButton @click="closeModal">{{ $t('close') }}</GhostButton>
        <MainButton dataTestId="hotel-offers-remove-modal-remove-button" @click="removeHotelOffer">
          <span v-if="isRemovingOfferLoading"><SmallDotLoader color="#fff" /></span>
          <span v-else>{{ $t('hotel_offers_cta_remove_offer') }} </span>
        </MainButton>
      </div>
    </template>
  </CustomModal>
</template>
<script setup>
import { computed, ref } from 'vue'

import CustomModal from '@/components/base/CustomModal.vue'
import GhostButton from '@/components/base/buttons/GhostButton.vue'
import SmallDotLoader from '@/components/base/loaders/SmallDotLoader.vue'
import MainButton from '@/components/base/buttons/MainButton.vue'
import useToastNotifications from '@/components/notifications/useToastNotifications'

import { useRemoveOffer } from '@/components/hotelOffers/queries'
import { selectedAccommodationId } from '@/layouts/queries'

const { displayNotification } = useToastNotifications()
const { removeOffer, isRemovingOfferLoading } = useRemoveOffer()
const emit = defineEmits(['closeModal'])
const closeModal = () => {
  emit('closeModal')
  removeFeedback.value = ''
}
defineProps({
  isOpen: Boolean,
})
const removeFeedback = ref('')
const numberOfCharacters = computed(() => removeFeedback.value.length)
const setRemoveFeedback = value => {
  removeFeedback.value = value
}

const removeHotelOffer = () => {
  removeOffer(
    {
      accommodationId: selectedAccommodationId.value,
      feedback: removeFeedback.value,
    },
    {
      onSuccess: () => {
        displayNotification({
          message: 'hotel_offers_success_removed',
          isTranslationKey: true,
          type: 'success',
        })
        closeModal()
      },
      onError: () => {
        displayNotification({
          message: 'something_went_wrong',
          isTranslationKey: true,
          type: 'error',
        })
      },
    }
  )
}
</script>
